import useShortcutScope from 'Hooks/useShortcutScope';
import useFormShortcuts from 'Hooks/useFormShortcuts';

// Single entry point for the "modal with Save/Cancel" recipe: pushes a
// scope for this modal instance (only while `visible`, so a modal that
// stays mounted and just toggles a flag - instead of unmounting - doesn't
// leak a permanently-active scope) and wires mod+S / mod+Enter / Escape to
// it via useFormShortcuts. One call replaces the useShortcutScope +
// useFormShortcuts pair that used to be duplicated at every call site.
//
// Permission gating lives with the caller, not here: pass `onSave: undefined`
// (or omit it) when the current user isn't allowed to save at all, so the
// shortcut - and its entry in the mod+/ help panel - simply doesn't exist
// for them, same as if the Save button itself weren't rendered.
//
// Pass `enterToSave: true` for single-field modals (rename, assign, create
// role/credential) where a plain Enter has always meant "submit" - see
// useFormShortcuts for why this is opt-in rather than the default.
const useModalShortcuts = ({
  id, visible = true, onSave, onCancel, canSave = true, saveLabel = 'Save', cancelLabel = 'Cancel', enterToSave = false
}) => {
  const scope = useShortcutScope(id, visible);

  useFormShortcuts({ onSave, onCancel, canSave, saveLabel, cancelLabel, enterToSave, scope });

  return scope;
};

export default useModalShortcuts;
